<div
  class="relative pr-xxsmall-x nordic-blue-50-bg surface-secondary border-bottom"
  data-testid="histogram"
  #histogramContainer
  role="presentation"
>
  <fin-scroll-handle-container
    #scrollContainer
    [elements]="bars()"
    class="nordic-blue-50-bg surface-secondary flex flex--center"
    (scrollElements)="barsScrolled.emit($event)"
    [disableKeyboardNavigation]="true"
  >
    <div class="flex flex--column-row flex--align-end ps-medium-t bar-container">
      @for (bar of range(); track bar.index; let i = $index) {
        @if (bar?.spacer) {
          <ng-container *ngTemplateOutlet="verticalSeparator; context: { label: bar?.spacer?.value }" />
        }

        <div
          class="flex flex--column flex--end link-hover border-top border-left border-right rounded-top-medium bar"
          [attr.data-testid]="'histogram-bar-' + i"
          [class.cheapest]="bar?.isCheapest"
          [class.noFlight]="bar.noFlight"
          [class.selected]="selected() === i && isLoading() === false"
          [class.loading]="isLoading()"
          [class.grey-25-bg]="isLoading()"
          [class.bg-primary]="isLoading()"
          #bar
          [style.height]="bar.height"
          (click)="scrollToBarByIndex(bar)"
        >
          <p class="text-align center font-body-small" data-testid="histogram-label">{{ bar.text }}</p>
          @if (isLoading()) {
            <span class="grey-bar center"></span>
          }
          @if (!bar.noFlight) {
            <p
              class="text-align center font-label-small"
              data-testid="histogram-price"
              [attr.data-nosnippet]="noSnippet() ? '' : null"
            >
              {{
                { amount: bar.amount, currencyCode: bar.currencyCode }
                  | finPrice: { abbreviate: true, useCustomFormat: true }
              }}
            </p>
          }
          @if (bar.noFlight) {
            <fcom-icon class="center icon-small ms-xxsmall-b" [name]="SvgLibraryIcon.FLIGHTS_UNAVAILABLE" />
          }
        </div>
      }
    </div>
  </fin-scroll-handle-container>
</div>

<ng-template #verticalSeparator let-label="label">
  <div class="flex flex--center flex--column flex--self-stretch" data-testid="histogram-spacer">
    <p class="font-body-small" data-testid="histogram-spacer-label">{{ label }}</p>
    <div class="border-left grow" [ngStyle]="CMS_STYLE_OVERRIDE"></div>
  </div>
</ng-template>
